import CompanyList from "./companies";

export default CompanyList;
